import $ from 'jquery';
import { subscribeToScroll, getScrollInstance, getScrollY } from '../core/ScrollService.js';
const initPopup = () => {
    const popup = document.getElementById('article-popup');
    if (!popup) return;

    const closeBtn = popup.querySelector('.popup-close');
    const header = document.querySelector('header');
    const footer = document.querySelector('footer');

    closeBtn.addEventListener('click', () => {
        if (popup.classList.contains('active')) {
            popup.classList.remove('active');
        }
    });

    const handlePopup = () => {
        if (!getScrollInstance()) return;

        const scrollY = getScrollY();
        const headerBottom = header ? header.offsetTop + header.offsetHeight : 0;
        const footerTop = footer ? footer.offsetTop : document.body.scrollHeight;
        const windowBottom = scrollY + window.innerHeight;

        if (scrollY > headerBottom && (windowBottom < footerTop)) {
            if (!popup.classList.contains('active')) {
                popup.classList.add('active');
            }
        } else {
            if (popup.classList.contains('active')) {
                popup.classList.remove('active');
            }
        }
    };

    subscribeToScroll(handlePopup, false);
    handlePopup();
};

export { initPopup };
